import { createIcon } from '@chakra-ui/icon';
import * as React from 'react';
export var CalendarIcon = createIcon({
  displayName: 'CalendarIcon',
  path: /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8 1a1 1 0 00-2 0v1H4a3 3 0 00-3 3v14a3 3 0 003 3h16a3 3 0 003-3V5a3 3 0 00-3-3h-2V1a1 1 0 10-2 0v1H8V1zm8 4V4H8v1a1 1 0 01-2 0V4H4a1 1 0 00-1 1v3h18V5a1 1 0 00-1-1h-2v1a1 1 0 11-2 0zm5 5H3v9a1 1 0 001 1h16a1 1 0 001-1v-9z",
    fill: "currentColor",
    fillRule: "evenodd"
  })
});
//# sourceMappingURL=Calendar.js.map